import { render, staticRenderFns } from "./EditChnlAdminDlg.vue?vue&type=template&id=5760f7d3"
import script from "./EditChnlAdminDlg.vue?vue&type=script&lang=js"
export * from "./EditChnlAdminDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports